import * as Sentry from '@sentry/nuxt'
import { scrubSentryEvent } from '~/utils/sentryScrub'

const config = useRuntimeConfig()

if (config.public.sentryDsn) {
  Sentry.init({
    dsn: config.public.sentryDsn,
    environment: config.public.sentryEnvironment || 'development',

    // Free plan: keep sample rates very low to stay within 5K errors/month
    tracesSampleRate: 0,

    // PII hardening: never auto-attach IPs, cookies, or request bodies.
    sendDefaultPii: false,

    // Disable replay (not included in free plan)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    // Drop events only for LOCAL dev builds (import.meta.dev). Deployed
    // environments — including the dev server — must report. The old guard
    // dropped anything with environment "development", which silenced the
    // deployed dev server entirely. Deployed events are scrubbed of sensitive
    // data before leaving the browser.
    beforeSend(event) {
      if (import.meta.dev) {
        return null
      }
      return scrubSentryEvent(event)
    },

    // Filter out noisy browser errors that aren't actionable
    ignoreErrors: [
      'ResizeObserver loop',
      'Network request failed',
      'Load failed',
      'ChunkLoadError',
    ],
  })
}
